import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useDrawerAccordionBaseStyles from "./styles/useDrawerAccordionBaseStyles";
import useDisplaySettingsAccordionStyles from "./styles/useDisplaySettingsAccordionStyles";
import { useLanguage, t } from "../../../contexts/LanguageContext";

function NorthIndicatorToggle({ checked, onChange }) {
  const baseClasses = useDrawerAccordionBaseStyles();
  const displayClasses = useDisplaySettingsAccordionStyles();
  const classes = { ...baseClasses, ...displayClasses };
  const { language } = useLanguage();

  return (
    <Accordion defaultExpanded className={classes.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.accordionSummary}
      >
        <Typography className={classes.accordionSummaryText}>
          {t("gpsSettings", language)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <FormControlLabel
          className={classes.formControlLabel}
          control={
            <Checkbox
              checked={checked}
              onChange={(e) => onChange(e.target.checked)}
              color="primary"
            />
          }
          label={t("northIndicator", language)}
        />
      </AccordionDetails>
    </Accordion>
  );
}

export default React.memo(NorthIndicatorToggle);
